import VGListener from "./src/vg";
import YaCounter from './src/modules/analytics/ym';

(function ($) {
	$(window).on('load', function() {
		VGListener.onLoad();
	});

	$(window).scroll(function () {
		VGListener.onScroll($(this));
	});

	$(document).ready(function () {
		VGListener.onReady();
	});

	$(window).resize(function () {
		VGListener.onResize($(this));
	});
})(jQuery);

// Modules
require ('./src/modules/social');
require('./src/modules/analytics/analytics');
require('./src/modules/bg');
require('./src/modules/video');
require('./src/modules/map');
require('./src/modules/limitLine');
require('./src/modules/dynamic_table');

window.bootstrap = window.vgp = require('../../../modules/index.esm');
window.ymetrika = new YaCounter();

// [[vegas]]
